export const PhoneNumber = '557591112865';
export const PrivacyPolicyURL = 'https://docs.undesk.com.br/POLÍTICA+DE+PRIVACIDADE+DO+UNDESK.pdf';
export const TermsOfServiceURL = 'https://docs.undesk.com.br/TERMOS+DE+USO+UNDESK.pdf';
export const RegisterURL = import.meta.env.VITE_BETA_ENV ? 'https://beta-app.undesk.com.br/register' : 'https://app.undesk.com.br/register';

const handleWhatsAppClick = (numero: string, mensagem: string) => {
  const mensagemCodificada = encodeURIComponent(mensagem);

  const url = `https://wa.me/${numero}?text=${mensagemCodificada}`;

  window.open(url, '_blank');
};

export default handleWhatsAppClick;
